import { Challenge, AppState } from '@/types';
import { CHALLENGE_TEMPLATES } from './challengeTemplates';

export function updateChallengeProgress(
  challenges: Challenge[], 
  state: AppState, 
  actionType: 'activity' | 'pet_care',
  activityName?: string
): Challenge[] {
  const now = new Date();
  
  return challenges.map(challenge => {
    if (challenge.status !== 'active' || challenge.endDate < now) {
      return { ...challenge, status: challenge.endDate < now ? 'expired' as const : challenge.status };
    }

    let newProgress = challenge.progress;

    switch (challenge.type) {
      case 'daily_streak':
        newProgress = Math.min(state.streak, challenge.target);
        break;
      
      case 'point_target':
        if (actionType === 'activity') {
          // For daily challenges, count only today's points
          if (challenge.id.startsWith('daily_')) {
            newProgress = state.activitiesLoggedToday * 10; // Assuming average 10 points per activity
          } else {
            newProgress = state.currentWeekPoints;
          }
        }
        break;
      
      case 'activity_count':
        if (actionType === 'activity' && activityName) {
          const template = Object.values(CHALLENGE_TEMPLATES).find(t => t.title === challenge.title);
          if (template && 'activityType' in template && template.activityType === activityName) {
            newProgress = state.activityCounts[activityName] || 0;
          }
        }
        break;
      
      case 'pet_care':
        // This would be updated when pet care actions are performed
        // For now, simulate based on pet stats
        if (actionType === 'pet_care' && state.virtualPet) {
          newProgress = Math.min(newProgress + 1, challenge.target);
        }
        break;
    }

    const isCompleted = newProgress >= challenge.target;
    const status = isCompleted ? 'completed' as const : 'active' as const;

    return {
      ...challenge,
      progress: newProgress,
      status
    };
  });
}